import { FC, Fragment, ReactNode } from 'react'
import { SideoverState } from '@/states'
import { TagValidation } from '@/helpers'
import { Input } from '@/ui/views'

const TagForm: FC = (): ReactNode => {
    const {
        Open,
        SetState,
        Form,
        Errors,
        Loading
    } = SideoverState()

    const HandleChange = (value: string, target: keyof TagFormInterface & keyof TagErrorInterface) => {
        if (Open && !Loading) {
            const form = structuredClone(Form)
            const errors = structuredClone(Errors)

            form[target] = value
            errors[target] = true

            SetState({
                Form: form,
                Errors: errors
            })
        }
    }

    return (
        <Fragment>
            <Input
                target='Name'
                label='Name'
                placeholder='Tag Name'
                required={true}
                value={Form?.Name}
                id='Name'
                // @ts-ignore
                onChange={HandleChange}
                showError={Errors?.Name}
                validationFunction={TagValidation}
                disabled={Loading}
            />
        </Fragment>
    )
}

export default TagForm
